import { useTranslation } from 'react-i18next';

import ChatIconButton from '$app-web/ui-kit/components/chat-icon-button';

import AvatarWithTitle from '../../components/avatar-with-title';
import { VOIP_CALL_TYPES } from '../../constants';
import useTones from '../../hooks/use-tones';
import {
    useCurrentStudyUsersData,
    useCurrentUserId,
    useDynamicMethods,
    useMethods,
    useVoip,
} from '../../state/chat-client.state';
import { getChatRoomTitle } from '../../utils/chat-client.utils';
import classes from './styles.module.scss';

const IncomingCallBox = () => {
    const { t } = useTranslation();

    const dynamicMethods = useDynamicMethods();
    const methods = useMethods();
    const voip = useVoip();
    const { incomingCallTone, declinedCallTone } = useTones();
    const currentStudyUsersData = useCurrentStudyUsersData();
    const currentUserId = useCurrentUserId();

    if (voip.incomingCallsData.length <= 0) {
        !incomingCallTone.paused && incomingCallTone.load();
        return null;
    }

    const currentIncomingCallData = voip.incomingCallsData[0];
    const room = dynamicMethods.getRoom(currentIncomingCallData.roomId);

    // According to browser's policy, audio is not played before the user interacts with the browser
    incomingCallTone.paused && incomingCallTone.play().catch(() => {});

    return (
        <div className={classes.root}>
            <div className={classes.inner}>
                <div className={classes.avatarTitleWrapper}>
                    <AvatarWithTitle
                        avatarColor={room.avatar.color}
                        avatarLabel={getChatRoomTitle(room, currentStudyUsersData, currentUserId, t)}
                        src={room.avatar.url}
                        subtitle={
                            currentIncomingCallData.type === VOIP_CALL_TYPES.VOICE
                                ? t('incoming_audio_call')
                                : t('incoming_video_call')
                        }
                        title={`${dynamicMethods.getRoomTitle(currentIncomingCallData.roomId) || ''} | ${t(
                            'from_study_with_placeholder',
                            [methods.getStudyName(room.studyId) || '']
                        )}`}
                    />
                </div>
                <div className={classes.actions}>
                    <ChatIconButton
                        icon={['fas', 'phone-slash']}
                        size="small"
                        className={classes.iconButton}
                        color="error"
                        onClick={() => {
                            declinedCallTone.play().catch(() => {});
                            methods.rejectIncomingVoipCall(currentIncomingCallData.id);
                        }}
                        fill
                    />
                    <ChatIconButton
                        icon={['fas', 'phone']}
                        size="small"
                        className={classes.iconButton}
                        color="success"
                        onClick={() => {
                            methods.answerIncomingVoipCall(currentIncomingCallData.id, true);
                        }}
                        fill
                    />
                    {currentIncomingCallData.type === VOIP_CALL_TYPES.VIDEO && (
                        <ChatIconButton
                            icon={['fas', 'video']}
                            size="small"
                            className={classes.iconButton}
                            color="success"
                            onClick={() => {
                                methods.answerIncomingVoipCall(currentIncomingCallData.id, false);
                            }}
                            fill
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

IncomingCallBox.propTypes = {};

export default IncomingCallBox;
